/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { httpV2 } from "@/api/index";
import {
	GET_GENERATOR_UPWINDBEARING_RESULT,
	GET_GENERATOR_DOWNWINDBEARING_RESULT,
	GET_GENERATOR_UPWINDBEARING_SUCCESS,
	GET_GENERATOR_DOWNWINDBEARING_SUCCESS,
	GET_GENERATOR_ROLLING_BEARING_RESULT_ERROR,
	RESET_GENERATOR_ROLLING_BEARING_RESULT,
} from "@/stores/actions/WindDiagnosticGeneratorRollingBearingResult";
import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";

const state = {
	status:     FetchStatus.Init,
	faDownWind: 0,
	faUpWind:   0,
	error:      {},
};

const actions = {
	[GET_GENERATOR_UPWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GENERATOR_UPWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GeneratorBearings`)
			.then((resp) =>
			{
				commit(GET_GENERATOR_UPWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GENERATOR_ROLLING_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GENERATOR_DOWNWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GENERATOR_DOWNWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GeneratorBearings`)
			.then((resp) =>
			{
				commit(GET_GENERATOR_DOWNWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GENERATOR_ROLLING_BEARING_RESULT_ERROR, error.response);
			});
	},
	[RESET_GENERATOR_ROLLING_BEARING_RESULT]: ({ commit }) =>
	{
		commit(RESET_GENERATOR_ROLLING_BEARING_RESULT);
	},
};

const mutations = {
	[GET_GENERATOR_UPWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GENERATOR_DOWNWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GENERATOR_UPWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.faUpWind = data.faUpWind;
	},
	[GET_GENERATOR_DOWNWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.faDownWind = data.faDownWind;
	},
	[GET_GENERATOR_ROLLING_BEARING_RESULT_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
	[RESET_GENERATOR_ROLLING_BEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loaded;
		state.faDownWind = DiagnosticRange.undefined;
		state.faUpWind = DiagnosticRange.undefined;
	},
};

export default {
	state,
	actions,
	mutations,
};
